import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Turnstile from "react-turnstile";
import Layout from "../../layout/Layout";
import PageBanner from "../../layout/PageBanner";
import { authService, CAPTCHA } from "../../services";
import { Panel, TextField } from "../../components/ui";

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();

  const [form, setForm] = useState({ email: "", password: "", remember: false });
  const [captchaToken, setCaptchaToken] = useState("");
  const [captchaKey, setCaptchaKey] = useState(Date.now());
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (authService.isLoggedIn()) navigate("/profile", { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChange = (key) => (event) => setForm((prev) => ({ ...prev, [key]: event.target.value }));

  const submit = async (event) => {
    event.preventDefault();
    setError("");
    if (!form.email || !form.password) {
      setError("กรุณากรอกอีเมลและรหัสผ่าน");
      return;
    }
    setLoading(true);
    try {
      await authService.login({ ...form, captchaToken });
      navigate(location.state?.from || "/profile", { replace: true });
    } catch (err) {
      setError(err.message);
      setCaptchaToken("");
      setCaptchaKey(Date.now());
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <PageBanner title="บริการครอบคลุมมากกว่า 200 เกม" breadcrumb={[{ label: "เข้าสู่ระบบ" }]} seed={4} />

      <div className="lucid-container" style={{ marginTop: -70, position: "relative", zIndex: 3, paddingBottom: 40 }}>
        <Panel style={{ maxWidth: 620, margin: "0 auto" }}>
          <h2 className="lt-panel__title lt-mb-24">เข้าสู่ระบบ</h2>

          <form onSubmit={submit}>
            <TextField
              label="อีเมล"
              type="email"
              placeholder="กรอกอีเมลที่ใช้สมัคร"
              value={form.email}
              onChange={onChange("email")}
              autoComplete="username"
            />
            <TextField
              label="รหัสผ่าน"
              type="password"
              placeholder="กรอกรหัสผ่าน"
              value={form.password}
              onChange={onChange("password")}
              autoComplete="current-password"
            />

            <label className="lt-flex lt-gap-8 lt-mb-16" style={{ alignItems: "center", fontSize: 14 }}>
              <input
                type="checkbox"
                checked={form.remember}
                onChange={(event) => setForm((prev) => ({ ...prev, remember: event.target.checked }))}
              />
              จดจำการเข้าสู่ระบบ
            </label>

            {CAPTCHA.siteKey ? (
              <div className="lt-mb-16">
                <Turnstile
                  key={captchaKey}
                  sitekey={CAPTCHA.siteKey}
                  onVerify={(token) => setCaptchaToken(token)}
                  onExpire={() => setCaptchaToken("")}
                  onError={() => setCaptchaToken("")}
                />
              </div>
            ) : null}

            {error ? <p className="lt-helper lt-helper--danger">{error}</p> : null}

            <button type="submit" className="lt-btn lt-btn--teal lt-btn--block" disabled={loading}>
              {loading ? "กำลังเข้าสู่ระบบ..." : "เข้าสู่ระบบ"}
            </button>
          </form>

          <div className="lt-flex-between lt-mt-24" style={{ fontSize: 14 }}>
            <Link to="/register">สมัครสมาชิก</Link>
            <Link to="/forgot-password">ลืมรหัสผ่าน?</Link>
          </div>
        </Panel>
      </div>
    </Layout>
  );
}
